import { render, staticRenderFns } from "./OverlayCartChange.vue?vue&type=template&id=1a209d72&"
import script from "./OverlayCartChange.vue?vue&type=script&lang=js&"
export * from "./OverlayCartChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a209d72')) {
      api.createRecord('1a209d72', component.options)
    } else {
      api.reload('1a209d72', component.options)
    }
    module.hot.accept("./OverlayCartChange.vue?vue&type=template&id=1a209d72&", function () {
      api.rerender('1a209d72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/pages/OverlayCartChange.vue"
export default component.exports